import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';

type Variables = {
  id: number;
  appointmentTypeId: number;
};

export type JooserCancelAppointment = {
  data: string;
};

export const useJooserCancelAppointment = createMutation<
  JooserCancelAppointment,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/reservations/${variables.id}/jooser/cancel-appointment`,
      method: 'PUT',
      data: { appointment_type_id: variables.appointmentTypeId },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
